var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:_vm.$style.logo,attrs:{"src":_vm.img,"alt":"Логотип Онлайн Лоджик"}})])}
var staticRenderFns = []

export { render, staticRenderFns }